import React, { useEffect, useState } from "react";
import "./sign-up.css";
import { components } from "react-select";
import makeAnimated, { MultiValue } from "react-select/animated";
import MySelect from "../components/CustomSelect";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../../assets/images/vct_technologies_logo_dark-xl.png";
import LogoV from "../../../assets/images/vct-technologies-logo-v.png";
import { Register, CheckNDA } from "api-services";
import { Link, useNavigate } from "react-router-dom";
import { Box, CircularProgress, Icon, Modal } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Questionnaire from "../questionnaire";
import PropTypes from "prop-types";

function Contact() {
  const dispatchData = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.authentication);

  // const [fullname, setFullname] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [jobRole, setJobRole] = useState("");
  const [companyWeb, setCompanyWeb] = useState("");
  const [checkNda, setCheckNda] = useState(false);
  const [optionSelected, setOptionSelected] = useState(null);
  const [password, setPassword] = useState("");

  const [iframeLoading, setIframeLoading] = useState(true);
  const [iframeLoadCount, setIframeLoadCount] = useState(0);

  const [passwordType, setPasswordType] = useState("password");

  const [envelopID, setEnvelopID] = useState(null);
  const [recipientId, setRecipientId] = useState(null);

  //   Form validation
  const [errors, setErrors] = useState({});
  const [ndaErrors, setNDAErrors] = useState({});

  //   Setting button text
  const buttonText = "Register";
  const [showFailureMessage, setShowFailureMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState("");
  const [showPasswordError, setShowPasswordError] = useState(false);

  // Questionnair
  const [tradeApi, setTradeApi] = useState("");
  const [showQuestionnair, setShowQuestionnair] = useState(false);

  // API Results for partial success/failure
  const [apiResults, setApiResults] = useState({
    successful: [],
    failed: [],
    showResults: false,
  });

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { token } = useSelector((state) => state.authentication);

  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, []);

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const animatedComponents = makeAnimated();

  const MultiValue = (props) => (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
      {props.selectProps.value.length > 1 ? (
        <span> + {props.selectProps.value.length - 1}</span>
      ) : (
        ""
      )}
    </components.MultiValue>
  );

  const handleChange = (selected) => {
    setOptionSelected(selected);
    setTradeApi(selected);
  };

  if (optionSelected) {
    let selectedProducts = optionSelected.filter((item) => item.value === "*");
    selectedProducts = selectedProducts.map(function (item) {
      return true;
    });
    const getRes = Object.assign(selectedProducts);
    let getDiv = document.querySelector(".api-select");
    getDiv?.classList?.add("not-active");
    if (getRes[0] === true) {
      getDiv?.classList?.remove("not-active");
      getDiv?.classList?.add("active");
    } else {
      getDiv?.classList?.add("not-active");
      getDiv?.classList?.remove("active");
    }
  }

  // Option for selectbox
  const options = [
    { value: 1, label: "Account Opening API" },
    { value: 2, label: "Funding API" },
    { value: 3, label: "Trading API" },
    { value: 4, label: "FIX Specifications" },
    { value: 5, label: "Journal API" },
  ];

  const togglePasswordType = () => {
    if (passwordType == "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  const handleValidation = () => {
    const tempErrors = {};
    let isValid = true;

    isValid = validateField(firstName, "firstname", tempErrors) && isValid;
    isValid =
      validateFieldLength(firstName, "firstname_length", tempErrors, 50) &&
      isValid;
    isValid =
      validateRegex(
        firstName,
        /^[a-zA-Z]*$/,
        "regexFName",
        "Please enter valid First Name",
        tempErrors
      ) && isValid;

    isValid = validateField(lastName, "lastname", tempErrors) && isValid;
    isValid =
      validateFieldLength(lastName, "lastname_length", tempErrors, 50) &&
      isValid;
    isValid =
      validateRegex(
        lastName,
        /^[a-zA-Z]*$/,
        "regexLName",
        "Please enter valid Last Name",
        tempErrors
      ) && isValid;

    isValid = validateField(email, "email", tempErrors) && isValid;
    isValid =
      validateFieldLength(email, "email_length", tempErrors, 150) && isValid;
    isValid =
      validateRegex(
        email,
        /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/,
        "email_type",
        null,
        tempErrors
      ) && isValid;
    isValid = validateField(company, "company_name", tempErrors) && isValid;
    isValid =
      validateFieldLength(company, "company_length", tempErrors, 150) &&
      isValid;

    isValid = validateField(jobRole, "jobRole", tempErrors) && isValid;
    isValid =
      validateFieldLength(jobRole, "jobrole_length", tempErrors, 100) &&
      isValid;

    isValid =
      validateRegex(
        companyWeb,
        /^https?:\/\/(www\.)?[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})(\/[^\s]*)?$/,
        "companyWeb",
        "Please enter valid URL",
        tempErrors
      ) && isValid;

    isValid = validateField(password, "password", tempErrors) && isValid;
    isValid =
      validateRegex(
        password,
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^_+=!*()@%&]).{8,}$/,
        "password_regex",
        "Password must be alphanumeric and at least 12 characters long, including one uppercase letter and a special character.",
        tempErrors
      ) && isValid;

    if (!optionSelected || optionSelected.length < 1) {
      tempErrors["optionSelected"] = true;
      isValid = false;
    }

    setErrors({ ...tempErrors });
    return isValid;
  };

  const validateField = (value, errorKey, tempErrors) => {
    if (value.length <= 0) {
      tempErrors[errorKey] = true;
      return false;
    }
    return true;
  };

  const validateFieldLength = (value, errorKey, tempErrors, maxLength) => {
    if (value.length > maxLength) {
      tempErrors[errorKey] = true;
      return false;
    }
    return true;
  };

  const validateRegex = (value, regex, errorKey, errorMessage, tempErrors) => {
    if (value.length > 0 && !regex.test(value)) {
      if (errorMessage) {
        tempErrors[errorKey] = errorMessage;
      } else {
        tempErrors[errorKey] = true;
      }
      return false;
    }
    return true;
  };

  const handleValidationNDA = () => {
    let tempErrors = {};
    let isValid = true;

    if (!checkNda) {
      tempErrors["checkNda"] = true;
      isValid = false;
    }

    setNDAErrors({ ...tempErrors });
    return isValid;
  };

  const clearFields = () => {
    // setFullname("");
    // setEmail("");
    setCompany("");
    setCompanyWeb("");
    setPassword("");
    setJobRole("");
    setOptionSelected(null);
  };

  const handleProceedToSignIn = () => {
    // Navigate to sign-in page since user needs to login first
    navigate("/authentication/sign-in");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let selectedProducts = [];
    if (optionSelected) {
      selectedProducts = optionSelected
        .filter((item) => item.value !== "*")
        .map((item) => ({
          APIID: item.value,
          APIName: item.label,
        }));
    }

    // Get Trade Value
    let tradingVal = "";
    if (tradeApi !== "") {
      const getTrd = tradeApi
        .filter((i) => i.value)
        .map((item) => (item.value === 3 ? item.value : null))
        .filter(Boolean); // Filter out nulls

      if (getTrd.length > 0) {
        tradingVal = getTrd.toString().replaceAll(",", "");
      }
    }

    const isValidForm = handleValidation();
    const isValidNDA = handleValidationNDA();
    if (isValidForm && isValidNDA) {
      setShowErrorMessage("");
      setShowFailureMessage(false);

      const data = {
        FirstName: firstName,
        LastName: lastName,
        Email: email,
        CompanyName: company,
        CompanyWebSite: companyWeb,
        JobRole: jobRole,
        Password: password,
        apirequestaccessItem: selectedProducts,
      };

      CheckNDA(
        dispatchData,
        { email },
        (res) => {
          Register(
            dispatchData,
            data,
            () => {
              if (tradingVal === "3") {
                setShowQuestionnair(true);
              }
              // Don't redirect - let setApiResults handle showing the results
            },
            setShowErrorMessage,
            clearFields,
            setApiResults
          );
        },
        (err) => {
          if (err?.status === "declined") {
            setShowErrorMessage(
              "This email is already in use. Please use a different email address"
            );
          } else if (err?.status === "delivered" || err?.status === "sent") {
            setShowErrorMessage("In order to proceed, kindly sign the NDA.");
          } else {
            setEnvelopID(null);
            setRecipientId(null);
            setShowErrorMessage(err);
          }
        }
      );
    }
  };

  const handleNDAAlreadySubmitted = () => {
    setShowErrorMessage("");
    let isValidForm = handleValidation();
    if (isValidForm) {
      CheckNDA(
        dispatchData,
        { email: email },
        (res) => {
          setCheckNda("true");
          document.getElementById("nda").checked = true;
          setErrors({});
          setShowErrorMessage(
            "You have already submitted the NDA. Please continue with the registration."
          );
        },
        (err) => {
          if (err?.status === "declined") {
            setErrors({});
            setShowErrorMessage(
              "This email is already in use. Please use a different email address."
            );
          } else {
            setIframeLoading(true);
            handleOpen();
            setEnvelopID(err?.envelopID);
            setRecipientId(err?.recipientId);
          }
        }
      );
    }
  };

  const onLoadIframe = (e) => {
    setIframeLoading(false);
    if (iframeLoadCount == 1) {
      setShowErrorMessage("");
      setIframeLoadCount(0);
      setTimeout(() => handleClose(), 5000);
    } else {
      setIframeLoadCount(iframeLoadCount + 1);
    }
  };

  const handleChangePassword = (e) => {
    setPassword(e.target.value);
  };

  // Form onChange Functions

  const handleChangejobRole = (event) => {
    setJobRole(event.target.value);
  };

  const handleChangeCompanyWebsite = (event) => {
    setCompanyWeb(event.target.value);
  };

  return (
    <>
      <div>
        <div className="wrap-register">
          <div className="container-fluid text-center">
            <div className="row">
              <div className="col-md-6 p-0">
                <div className="bg-common">
                  <div className="text-start cred">
                    <Link to="/">
                      <img
                        src={Logo}
                        alt="VCT Technologies LLC"
                        className="cred-logo"
                      />
                    </Link>
                    <h1 className="cred-title ps-2">Build with Us</h1>
                    <p className="cred-desc ps-2">
                      By creating a free account, you can:
                    </p>
                    <ul className="cred-list ">
                      <li>Access our easy-to-use Next Generation APIs</li>
                      <li>
                        Use sample data to try out our APIs in our sandbox{" "}
                        <br />
                        environment
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 p-5 bg-trans">
                <div className="row justify-content-md-center">
                  {showQuestionnair ? (
                    <Questionnaire
                      name={`${firstName} ${lastName}`}
                      email={email}
                    />
                  ) : apiResults.showResults ? (
                    <div className="col-md-12 col-lg-10 p-lg-5">
                      <Link to="/">
                        <img
                          src={LogoV}
                          className="cred-logo"
                          alt="VCT Technologies LLC"
                        />
                      </Link>

                      <div className="registration-status-container">
                        <div className="status-header">
                          {(() => {
                            // Check if User Creation was successful
                            const userCreation = [
                              ...apiResults.successful,
                              ...apiResults.failed,
                            ].find((api) => api.name === "User Creation");

                            if (
                              userCreation &&
                              userCreation.status === "Success"
                            ) {
                              return (
                                <>
                                  <div className="success-icon">✓</div>
                                  <h2 className="status-title">
                                    You're successfully registered!
                                  </h2>
                                  <p className="status-subtitle">
                                    Here's the status of your registered APIs.
                                  </p>
                                </>
                              );
                            } else {
                              return (
                                <>
                                  <div className="error-icon-header">✕</div>
                                  <h2 className="status-title error">
                                    Registration Failed!
                                  </h2>
                                  <p className="status-subtitle">
                                    {userCreation
                                      ? userCreation.message
                                      : "User registration could not be completed."}
                                  </p>
                                </>
                              );
                            }
                          })()}
                        </div>

                        <div className="apis-grid">
                          {apiResults.successful
                            .filter((api) => api.name !== "User Creation")
                            .map((api, index) => (
                              <div key={index} className="api-item">
                                <div className="api-status-card success">
                                  <div className="api-icon success-icon-small">
                                    ✓
                                  </div>
                                  <div className="api-name">{api.name}</div>
                                </div>
                                <div className="api-status-text success">
                                  {(() => {
                                    const apiSuccessful =
                                      apiResults.successful.filter(
                                        (api) => api.name !== "User Creation"
                                      );
                                    const apiFailed = apiResults.failed.filter(
                                      (api) => api.name !== "User Creation"
                                    );

                                    // If all APIs are successful (no failures), show "Request Successful"
                                    if (
                                      apiSuccessful.length > 0 &&
                                      apiFailed.length === 0
                                    ) {
                                      return "Request Successful";
                                    }
                                    // Otherwise show "Access Granted"
                                    return "Request Successful";
                                  })()}
                                </div>
                              </div>
                            ))}

                          {apiResults.failed
                            .filter((api) => api.name !== "User Creation")
                            .map((api, index) => (
                              <div key={index} className="api-item">
                                <div className="api-status-card failed">
                                  <div className="api-icon failed-icon-small">
                                    ✕
                                  </div>
                                  <div className="api-name">{api.name}</div>
                                </div>
                                <div className="api-status-text failed">
                                  {(() => {
                                    const apiSuccessful =
                                      apiResults.successful.filter(
                                        (api) => api.name !== "User Creation"
                                      );
                                    const apiFailed = apiResults.failed.filter(
                                      (api) => api.name !== "User Creation"
                                    );

                                    // If all APIs failed (no successes), show "Request Unsuccessful"
                                    if (
                                      apiSuccessful.length === 0 &&
                                      apiFailed.length > 0
                                    ) {
                                      return "Request Unsuccessful";
                                    }
                                    // Otherwise show "Access Denied"
                                    return "Request Unsuccessful";
                                  })()}
                                </div>
                              </div>
                            ))}
                        </div>

                        {/* Mixed Results Message */}
                        {(() => {
                          const apiSuccessful = apiResults.successful.filter(
                            (api) => api.name !== "User Creation"
                          );
                          const apiFailed = apiResults.failed.filter(
                            (api) => api.name !== "User Creation"
                          );

                          if (
                            apiSuccessful.length > 0 &&
                            apiFailed.length > 0
                          ) {
                            return (
                              <div className="status-message warning">
                                <div className="message-text">
                                  <strong>
                                    Some API(s) didn't go through{" "}
                                    <span className="warning-icon">⚠</span>
                                  </strong>
                                  <p>
                                    Your successful API(s) are ready to use once
                                    logged in. You can retry the others anytime
                                    from your dashboard.
                                  </p>
                                </div>
                              </div>
                            );
                          }

                          if (
                            apiSuccessful.length === 0 &&
                            apiFailed.length > 0
                          ) {
                            return (
                              <div className="status-message error">
                                <div className="message-text">
                                  <p>
                                    You can retry any unsuccessful API(s)
                                    anytime from your dashboard once logged in.
                                  </p>
                                </div>
                              </div>
                            );
                          }

                          if (
                            apiSuccessful.length > 0 &&
                            apiFailed.length === 0
                          ) {
                            return (
                              <div className="status-message ">
                                <div className="message-text">
                                  <p>
                                    Thank you for your submission. We'll be in
                                    touch real soon!
                                  </p>
                                </div>
                              </div>
                            );
                          }

                          return null;
                        })()}

                        {(() => {
                          // Check if User Creation was successful
                          const userCreation = [
                            ...apiResults.successful,
                            ...apiResults.failed,
                          ].find((api) => api.name === "User Creation");

                          // Only show dashboard button if User Creation was successful
                          if (
                            userCreation &&
                            userCreation.status === "Success"
                          ) {
                            return (
                              <button
                                className="btn cred-btn-contact my-auto full-width-btn"
                                onClick={handleProceedToSignIn}
                              >
                                Go to Dashboard
                              </button>
                            );
                          }
                        })()}
                      </div>
                    </div>
                  ) : (
                    <form
                      className="col-md-12 col-lg-10 p-lg-5"
                      onSubmit={handleSubmit}
                    >
                      <Link to="/">
                        <img
                          src={LogoV}
                          className="cred-logo"
                          alt="VCT Technologies LLC"
                        />
                      </Link>
                      <h3 className="cred-form-title text-start">
                        Register for Access
                      </h3>
                      <p className="cred-form-desc text-start">
                        Already have an account?{" "}
                        <Link to="/authentication/sign-in">Sign In </Link>
                      </p>
                      <div className="row">
                        <div className="col-12 col-lg-6 mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="firstname"
                            name="firstname"
                            placeholder="First Name*"
                            value={firstName}
                            onChange={(e) => {
                              setFirstName(e.target.value);
                            }}
                          />
                          {errors?.firstname && (
                            <p className="text-red">
                              First Name cannot be empty.
                            </p>
                          )}
                          {errors?.firstname_length && (
                            <p className="text-red">
                              First Name cannot be more than 50 characters.
                            </p>
                          )}
                          {errors?.regexFName && (
                            <p className="text-red">{errors.regexFName}</p>
                          )}
                        </div>
                        <div className="col-12 col-lg-6 mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="lastname"
                            name="lastname"
                            placeholder="Last Name*"
                            value={lastName}
                            onChange={(e) => {
                              setLastName(e.target.value);
                            }}
                          />
                          {errors?.lastname && (
                            <p className="text-red">
                              Last Name cannot be empty.
                            </p>
                          )}
                          {errors?.lastname_length && (
                            <p className="text-red">
                              Last Name cannot be more than 50 characters.
                            </p>
                          )}
                          {errors?.regexLName && (
                            <p className="text-red">{errors.regexLName}</p>
                          )}
                        </div>
                        <div className="col-12 col-lg-6 mb-3">
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            placeholder="Email Address*"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                            }}
                          />
                          {errors?.email && (
                            <p className="text-red">Email cannot be empty.</p>
                          )}
                          {errors?.email_length && (
                            <p className="text-red">
                              Email cannot be more than 150 characters.
                            </p>
                          )}
                          {!errors?.email && errors?.email_type && (
                            <p className="text-red">
                              Please enter valid email address.
                            </p>
                          )}
                        </div>
                        <div className="col-12 col-lg-6 mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="company_name"
                            name="company_name"
                            placeholder="Company Name*"
                            value={company}
                            onChange={(e) => {
                              setCompany(e.target.value);
                            }}
                          />
                          {errors?.company_name && (
                            <p className="text-red">
                              Company Name is required.
                            </p>
                          )}
                          {errors?.company_length && (
                            <p className="text-red">
                              Company Name cannot be more than 150 characters.
                            </p>
                          )}
                        </div>
                        <div className="col-12 col-lg-6 mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="job_role"
                            name="job_role"
                            placeholder="Job Role*"
                            value={jobRole}
                            onChange={handleChangejobRole}
                          />
                          {errors?.jobRole && (
                            <p className="text-red">
                              Job Role cannot be empty.
                            </p>
                          )}
                          {errors?.jobRole_length && (
                            <p className="text-red">
                              Job Role cannot be more than 100 characters.
                            </p>
                          )}
                        </div>
                        <div className="col-12 col-lg-6 mb-3">
                          <input
                            type="url"
                            className="form-control"
                            id="company_website"
                            name="company_website"
                            placeholder="company Website"
                            value={companyWeb}
                            onChange={handleChangeCompanyWebsite}
                          />
                          {errors?.companyweb_length && (
                            <p className="text-red">{errors?.companyWeb}</p>
                          )}
                          {errors?.companyWeb && (
                            <p className="text-red">{errors?.companyWeb}</p>
                          )}
                        </div>
                        <div className="col-12 col-lg-6 mb-3">
                          <div className="password-field">
                            <input
                              type={passwordType}
                              className={
                                errors.password_regex
                                  ? "form-control padding-password-field"
                                  : "form-control"
                              }
                              id="password"
                              name="password"
                              placeholder="Password*"
                              value={password}
                              onChange={handleChangePassword}
                            />
                            <Icon
                              className={
                                errors.password_regex
                                  ? "password-input-icon padding-password-input-icon"
                                  : "password-input-icon"
                              }
                              onClick={togglePasswordType}
                            >
                              {passwordType == "password"
                                ? "visibility"
                                : "visibility_off"}
                            </Icon>
                            {errors?.password_regex ? (
                              <Icon
                                className="password-input-icon red"
                                onMouseEnter={() => {
                                  setShowPasswordError(true);
                                }}
                                onMouseLeave={() => {
                                  setShowPasswordError(false);
                                }}
                                onClick={togglePasswordType}
                              >
                                info_outlined
                              </Icon>
                            ) : (
                              <></>
                            )}
                            {showPasswordError && (
                              <div className=" error-box only-reg">
                                <p className="text-red">
                                  {errors?.password_regex}
                                </p>
                              </div>
                            )}
                          </div>
                          {errors?.password && (
                            <p className="text-red">
                              Password cannot be empty.
                            </p>
                          )}
                        </div>
                        <div className="col-12 col-lg-6 mb-3 api-select">
                          <MySelect
                            placeholder="Which API are you interested in?*"
                            options={options}
                            isMulti
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            components={{
                              Option,
                              MultiValue,
                              animatedComponents,
                            }}
                            onChange={handleChange}
                            allowSelectAll={true}
                            value={optionSelected?.filter(
                              (item) => item?.value
                            )}
                          />
                          {errors?.optionSelected && (
                            <p className="text-red">Please select an API</p>
                          )}
                        </div>
                        <div className="col-12 col-lg-12 mb-3">
                          <div className="form-check">
                            <label
                              className="form-check-label"
                              htmlFor="flexCheckDefault"
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="nda"
                                id="nda"
                                checked={checkNda}
                                onChange={(e) => setCheckNda(e.target.checked)}
                              />{" "}
                              I have read and agree to the terms mentioned in
                              the
                              <button
                                type="button"
                                onClick={() => handleNDAAlreadySubmitted()}
                                className="px-1 button"
                              >
                                NDA
                              </button>
                            </label>
                            {ndaErrors?.checkNda && (
                              <p className="text-red">
                                Please agree to the NDA to proceed.
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="container justify-content-center">
                            <div className="d-grid gap-2 col-12 col-md-12 mx-auto mb-3 text-left res">
                              {showFailureMessage && (
                                <p className="text-error">
                                  Oops! Something went wrong, please try again.
                                </p>
                              )}

                              {showErrorMessage != "" && (
                                <pre className="text-error">
                                  {showErrorMessage}
                                </pre>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="d-grid gap-2 col-8 col-md-8 col-lg-5 mx-auto mb-3">
                          <button
                            className="btn cred-btn-contact my-auto"
                            onClick={handleSubmit}
                            disabled={loading}
                          >
                            {loading ? (
                              <CircularProgress
                                size={25}
                                color="white"
                                className="loaderbtn"
                              />
                            ) : (
                              buttonText
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                  <div className="footer row justify-content-md-center">
                    <div className="col-md-12 col-lg-9 bg-trans p-0">
                      <div className="wrap-footer-inners">
                        <hr />
                        <Link to="/privacypolicy" target="_blank">
                          Privacy Policy
                        </Link>
                        <Link to="/termsofuse" target="_blank">
                          Terms of Use
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleClose();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {iframeLoading ? (
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <CircularProgress color="success" size={50} />
              <MDTypography color="secondary" mt={2}>
                Loading....
              </MDTypography>
            </MDBox>
          ) : (
            <></>
          )}
          <iframe
            title="NDA"
            height="100%"
            style={{ borderRadius: 10, width: "100%" }}
            src={`${window?.globalConfig?.baseURLDocuSign}&Name=${firstName} ${lastName}&Email=${email}&Company=${company}&JobTitle=${jobRole}&EnvelopID=${envelopID}&RecipientId=${recipientId}`}
            onLoad={(e) => onLoadIframe(e)}
            allow="fullscreen" // Specify other permissions as needed
          />
        </Box>
      </Modal>
    </>
  );
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  height: "90%",
  bgcolor: "#000",
  borderRadius: 2,
  boxShadow: 24,
  p: 0,
};
Option.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
};

// MultiValue.propTypes = {
//   data: PropTypes.shape({
//     label: PropTypes.string.isRequired,
//   }).isRequired,
//   selectProps: PropTypes.shape({
//     value: PropTypes.array.isRequired,
//   }).isRequired,
// };

MultiValue.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
  }).isRequired,
  selectProps: PropTypes.shape({
    value: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};
export default Contact;
